import { MenuListItems } from "../common/Sidebar/MenuListItems";
import { SystemModulesEnum, SystemUsersEnum } from "./SystemUsers";

const getSingleModule = (moduleId) => {
  const data = localStorage.getItem("modulePermissions");
  let modules = [];
  try {
    modules = data ? JSON.parse(data) : [];
  } catch (error) {
    console.error("Invalid JSON in localStorage:", error);
  }
  if (!Array.isArray(modules)) {
    modules = [];
  }
  return modules.find((item) => item.moduleId === moduleId);
};

//for single parent module permission list.
export const PermissionService = (moduleId) => {
  const singleModule = getSingleModule(moduleId);
  const permission =
    singleModule?.features?.map((item) => item.featureName) || [];
  return permission;
};

export const PermissionServiceChild = (moduleId, childModuleName) => {
  const parentModule = getSingleModule(moduleId);
  const childModule = parentModule?.childMenu?.find(
    (item) => item.name === childModuleName,
  );
  const permission =
    childModule?.features?.map((item) => item.featureName) || [];
  return permission;
};

export const childModulePermissions = (moduleId, childModuleName) => {
  const parentModule = getSingleModule(moduleId);
  const childModule = parentModule?.subMenu?.find(
    (item) => item.name === childModuleName,
  );
  const perm = childModule?.features?.map((el) => el.featureName) || [];
  return perm;
};

export const enabledTabs = (moduleId) => {
  const parentModule = getSingleModule(moduleId);
  if (moduleId === 5) {
    return ["Basic Information"];
  }
  let tabs = parentModule?.subMenu?.map((el) => el.name) || [];
  if (
    moduleId === 2 &&
    (tabs.includes("Distributor Basic Details") ||
      tabs.includes("Distributor Association Details") ||
      tabs.includes("Distributor Subscription Details"))
  ) {
    tabs = ["Basic Information", ...tabs];
  }
  return tabs;
};

export const getModuleId = (userTypeId) => {
  let moduleName = "";

  switch (userTypeId) {
    case SystemUsersEnum.ADMIN:
    case SystemUsersEnum.SUPERADMIN:
      moduleName = SystemModulesEnum.SUPER_ADMIN;
      break;
    case SystemUsersEnum.DISTRIBUTOR:
      moduleName = SystemModulesEnum.DISTRIBUTORS;
      break;
    case SystemUsersEnum.ENTERPRISE:
      moduleName = SystemModulesEnum.ENTERPRISE_GROUPS;
      break;
    case SystemUsersEnum.SUBSCRIBER:
      moduleName = SystemModulesEnum.SUBSCRIBERS;
      break;
    default:
      break;
  }

  switch (moduleName) {
    case SystemModulesEnum.SUPER_ADMIN:
    case SystemModulesEnum.ADMIN:
      return MenuListItems.find((item) => item.name === "Users").moduleId;
    case SystemModulesEnum.DISTRIBUTORS:
      return MenuListItems.find((item) => item.name === "Distributors")
        .moduleId;
    case SystemModulesEnum.ENTERPRISE_GROUPS:
      return MenuListItems.find((item) => item.name === "Enterprise Groups")
        .moduleId;
    case SystemModulesEnum.SUBSCRIBERS:
      return MenuListItems.find((item) => item.name === "Subscribers").moduleId;
    default:
      return null;
  }
};

export const PermissionEnum = {
  LIST: "List",
  CREATE: "Create",
  UPDATE: "Update",
};

/**
 * Checks whether the current user has a specific permission on a module.
 *
 * Reads from `localStorage("modulePermissions")` via `PermissionService(moduleId)`.
 *
 * @param {number} moduleId - The module id to check (e.g. 68 for "Ads").
 *                            Use values from `MenuListItems` / `SystemModulesEnum`.
 * @param {string} permission - The feature name to check. Pass a value from
 *                              `PermissionEnum` (e.g. `PermissionEnum.CREATE`),
 *                              or a raw string like `"List"`, `"Create"`,
 *                              `"Update"`, `"Delete"`.
 * @returns {boolean} `true` if the user has the permission for the module;
 *                    `false` when either arg is missing, the module is not in
 *                    the user's permissions, or the feature is not granted.
 *
 * @example
 *   if (hasModulePermission(68, PermissionEnum.CREATE)) {
 *     // show Add button
 *   }
 */
export const hasModulePermission = (moduleId, permission) => {
  if (!moduleId || !permission) return false;

  // Look up `moduleId` at the top level first, then fall back to any nested
  // subMenu entry (e.g. "Ads" moduleId 68 lives under "Distributors" moduleId 2).
  const data = localStorage.getItem("modulePermissions");
  let modules = [];

  try {
    modules = data ? JSON.parse(data) : [];
  } catch (error) {
    console.error("Invalid JSON in localStorage:", error);
  }
  if (!Array.isArray(modules)) return false;

  let target = modules.find((item) => item.moduleId === moduleId);
  if (!target) {
    for (const parent of modules) {
      const child = parent?.subMenu?.find((sub) => sub.moduleId === moduleId);
      if (child) {
        target = child;
        break;
      }
    }
  }

  const features = target?.features?.map((f) => f.featureName) || [];
  return features.includes(permission);
};
